import * as React from 'react';
import * as style from './style.css';
import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var NotAvailableScreen = function NotAvailableScreen(_ref) {
  var onHouseFilterReset = _ref.onHouseFilterReset,
    title = _ref.title;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: style['image'],
      children: /*#__PURE__*/_jsx("div", {
        className: style['logo']
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: style['controls'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: style['description'],
        children: [/*#__PURE__*/_jsx(UIHeading2, {
          children: title
        }), /*#__PURE__*/_jsx(UIText1, {
          children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439"
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          size: "XS",
          onClick: onHouseFilterReset,
          children: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043A\u043E\u0440\u043F\u0443\u0441\u0430"
        })
      })]
    })]
  });
};